import { createRequestActionTypes } from '../../helpers'

export const TYPE_NAMES = {
  en: {
    tutorial: 'Tutorial',
    guide: 'Troubleshooting Guide',
    faq: 'FAQ',
    video: 'Video',
    accountfaq: 'FAQ'
  },
  'es-ud': {
    tutorial: 'Tutoriales',
    guide: 'Guías de Solución de Problemas',
    faq: 'FAQ',
    video: 'Video',
    accountfaq: 'FAQ'
  },
  es: {
    tutorial: 'Tutoriales',
    guide: 'Guías de Solución de Problemas',
    faq: 'FAQ',
    video: 'Video',
    accountfaq: 'FAQ'
  }
}

export const TYPE_REDIRECT = {
  tutorial: 'tutorials',
  guide: 'guides',
  faq: 'faqs',
  video: 'videos',
  accountfaq: 'expresshelp'
}

export const FETCH_SUGGESTIONS = createRequestActionTypes(
  'SEARCH',
  'FETCH_SUGGESTIONS'
)



// WEBPACK FOOTER //
// ./src/containers/ESSearch/constants.js